<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-card
        class="mx-auto rounded-5 pb-5 test-parent text-center"
        :elevation="hover ? 1 : 0"
        :class="[
          { 'on-hover': hover },
          market.status === 'Integrated' && 'border-success bg-light',
        ]"
        @click="handleIntegration"
        :ripple="true"
        :loading="loading"
      >
        <template slot="progress">
          <v-progress-linear
            color="info"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>
        <div v-if="market.status === 'Coming Soon'" class="soon-box">
          <h6 class="mt-2">Coming Soon...</h6>
        </div>
        <div class="pt-2">
          <v-img
            class="image overflow-hidden"
            :src="market.logo"
            height="150px"
            width="200"
            contain
            eager
          ></v-img>
        </div>

        <v-icon class="icon-box" :color="detectButtonColor" size="25">
          {{ detectIcon }}
        </v-icon>
      </v-card>
    </v-hover>
    <h6 class="text-center" :class="detectTextColor">
      {{ market.marketName }}
    </h6>
  </div>
</template>

<script>
export default {
  props: ["market"],
  data() {
    return {
      loading: false,
      buttonColor: "",
      user: JSON.parse(localStorage.getItem("user"))?.id,
      rip: false,
    };
  },

  methods: {
    async handleIntegration() {
      if (this.market.status === "Coming Soon") return;

      this.loading = true;
      if (
        this.market?.status === "Integrated" ||
        this.market?.id === "woocommerce"
      ) {
        setTimeout(() => {
          this.$router.push({
            name: "integrations-form",
            query: { ...this.market },
          });

          this.loading = false;
        }, 1000);
      } else if (this.market?.id === "noon") {
        window.location.href = "https://westore.ai/noon-integration";
      } else {
        this.$router.push(
          `/integrations/${this.market.id}/handshake?user_id=${this.user}`
        );
      }
    },
  },

  computed: {
    detectButtonColor() {
      switch (this.market.status) {
        case "Coming Soon":
          return "light";

        case "Integrated":
          return "success";

        default:
          return "info";
      }
    },
    detectTextColor() {
      switch (this.market.status) {
        case "Coming Soon":
          return "text-muted opacity-50";

        case "Integrated":
          return "text-muted";
        case "In Progress":
          return "In Progress";

        default:
          return "text-primary";
      }
    },
    detectIcon() {
      switch (this.market.status) {
        case "Coming Soon":
          return "$vuetify.icons.soon";
        case "In Progress":
          return "mdi-sync-circle";
        case "Integrated":
          return "mdi-checkbox-marked";

        default:
          return "mdi-plus-box";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image {
  backface-visibility: hidden;
  margin: 0 auto;
}
.test-parent {
  position: relative;
  overflow: hidden;
  backface-visibility: hidden;
  border: 2px solid var(--v-info-base);
  border-radius: 10px;
}
.icon-box {
  position: absolute;
  top: 3px;
  right: 5px;
  z-index: 200;
  &__custom {
    background-color: var(--v-info-base);
    padding: 9px;
    border-radius: 50%;
  }
}
.v-card {
  overflow: hidden;
  transition: all 0.4s ease-in-out;
  backface-visibility: hidden;
}

.v-card:hover {
  cursor: pointer;
  transform: scale(1.005);
}
.v-ripple__container {
  background-color: red;
  color: red;
}
.soon-box {
  height: 100%;
  width: 100%;
  text-align: center;
  background-color: var(--v-shadow-base);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  opacity: 0.5;
}
</style>
